export default function Pager({ offset, limit, total, onOffset }: {
  offset: number; limit: number; total: number; onOffset: (offset: number) => void;
}) {
  const from = total ? offset + 1 : 0;
  const to = Math.min(offset + limit, total);
  return (
    <div className="flex items-center justify-between gap-2 flex-wrap text-xs text-slate-500 pt-2">
      <span className="font-mono">{from}–{to} of {total}</span>
      <div className="flex gap-1.5">
        <button className="btn" disabled={offset <= 0} onClick={() => onOffset(Math.max(0, offset - limit))}>Newer</button>
        <button className="btn" disabled={offset + limit >= total} onClick={() => onOffset(offset + limit)}>Older</button>
      </div>
    </div>
  );
}
